import React from 'react';
import Alert from '../../../components/Alert/Alert';
import useStyles from './RegistrationSuccess.styles';

import { Box, Typography } from '@material-ui/core';
import {
  getSuccessAlertTitle,
  isHtml,
  sanitizeHtmlWithWhitelist,
} from '../../../utils/registrationHelpers';

export const DEFAULTS = {
  BODY: 'You’ve purchased an enterprise product that requires some additional setup. A representative from our Customer Success Team will be contacting you within two business days with your account credentials. Please contact Support through our website if you have any questions.',
  ALERT: 'Success! Registration Complete.',
  ALERT_V2: 'Registration submitted',
  REDIRECT:
    'You will be redirected in the next 15 seconds. If you are not redirected, please copy and paste this url into your browser - ',
};

const RegistrationSuccess = ({
  successBodyMessage,
  redirectMessage,
  redirectUri,
  registrationData,
}) => {
  const classes = useStyles();

  const successAlertTitle = getSuccessAlertTitle({
    alertMessage: DEFAULTS.ALERT_V2,
    registrationData,
  });

  const isSuccessBodyHtml = isHtml(successBodyMessage);
  const sanitizedHtml = isSuccessBodyHtml
    ? sanitizeHtmlWithWhitelist(successBodyMessage)
    : '';

  return (
    <div className={classes.root}>
      <Alert appearance="success" title={successAlertTitle} />

      {isSuccessBodyHtml ? (
        <Box className={classes.body}>
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizedHtml,
            }}
          ></div>
        </Box>
      ) : (
        <Typography className={classes.body}>
          {successBodyMessage || DEFAULTS.BODY}
        </Typography>
      )}

      {redirectUri && (
        <Box className={classes.paragraph}>
          {redirectMessage || DEFAULTS.REDIRECT}
          <a href={redirectUri}> {redirectUri} </a>
        </Box>
      )}
    </div>
  );
};

export default RegistrationSuccess;
